import {Button} from "../Button";
import {useTranslation} from "react-i18next";
import type { I18NButtonProps } from "./I18NButton.interface";

/**
 * Primary UI component for user interaction
 */
export function I18NButton (props:I18NButtonProps) {
    
    const {t} = useTranslation();

    return (
        <Button label={t(props.i18n)} mode={props.mode} className={props.className} onClick={props.onClick} disabled={props.disabled} border={props.border} id={props.id} type={props.type} hoverText={props.hoverText} icon={props.icon} />
    );
};